module.exports = __webpack_public_path__ + "static/media/DSC_0465.76f58469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0465.jpg
// module id = 581
// module chunks = 0